import { useNavigate } from 'react-router-dom';
import { Upload } from 'lucide-react';
import { Button } from '@/components/ui';
import { useModuleAccess } from '@/hooks/useAccountModules';
import { LEAD_IMPORT_MODULE_KEY } from '@/lib/leadImport';

/**
 * The Leads page's "Import" header button.
 *
 * Shown only to admins (the importer lives under /admin, which RequireAdmin
 * gates at level 3, and the import endpoint applies the same bar) on an
 * account with the opt-in Lead Import module explicitly active. `explicit`
 * needs a fresh module fetch, so the button appears once that lands rather
 * than flashing from a stale saved seed — the same way the WhatsApp and Zernio
 * controls behave.
 *
 * Its own component so the gate can be tested without rendering the whole
 * Leads page.
 */
export function LeadImportButton({ isAdmin }: { isAdmin: boolean }) {
  const navigate = useNavigate();
  const { explicit } = useModuleAccess(LEAD_IMPORT_MODULE_KEY);

  if (!isAdmin || !explicit) return null;

  return (
    <Button
      variant="secondary"
      size="sm"
      leftIcon={<Upload className="h-4 w-4" />}
      onClick={() => navigate('/admin/import/leads')}
    >
      Import
    </Button>
  );
}
